export class KsGroup {
    id = '';
    groupName = '';
    roomName = '';
    //群头像
    headPortrait = '';
    createTime?: Date;
    createName = '';
    updateTime?: Date;
    updateName = '';
    //默认0   1是删除
    // isdelete = '';
}
